import { Route, Routes } from 'react-router-dom';
import Hero from './Components/Hero';
import Register from './Components/Register';
import UsernameInput from './Components/UsernameInput';
import Profile from './Components/Profile';
// import Footer from './Components/Footer';
import { useEffect, useState } from 'react';
import Nav from './Components/Nav';
import ResponsiveMenu from './Components/ResponsiveMenu';
// import Cookies from './Cookies';
import PublicProfile from './Components/PublicProfile';
import Footer2 from './Components/Footer2';
import Shop from './Components/Shop';
import ProductDetails from './Components/ProductDetails';
import Cart from './Components/Cart';
import ScrollToTop from './Components/ScrollToTop';
import WhatsAppButton from './Components/WhatsAppButton';
import SetUp from './Components/SetUp';
import Rewards from './Components/Rewards';
import RewardsPage from './Components/RewardsPage';
import Homes from './Home';
import About from './Components/About';
import ContactUs from './Components/ContactUs';
import PaymentSuccess from './Components/PaymentSuccess';
import FAQPage from './Components/FAQ';
import TermsAndConditions from './Components/TermsAndConditions';
import PrivacyPolicy from './Components/PrivacyPolicy';
import HotDeals from './Components/HotDeals';
import { PopupProvider } from './Components/PopupManager';
import PopupOrchestrator from './Components/PopupOrchestrator';
import Survey from './Components/Survey';
import DigitalAssistant from './Components/DigitalAssistant';


function App() {
  const [theme, setTheme] = useState("light");
  const element = document.documentElement;

  useEffect(() => {
    localStorage.removeItem("theme");
    if (theme === "dark") {
      element.classList.add("dark");
    } else {
      element.classList.remove("dark");
    }
  }, [theme, element.classList]);

  return (
    <PopupProvider>
    <div className='dark:bg-black text-center items-center'>
      <div className='text-center items-center flex flex-col'>
        <Nav theme={theme} setTheme={setTheme} />
      </div>
      <PopupOrchestrator />
      <Routes>
        <Route path='/' element={<Hero theme={theme} setTheme={setTheme} />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/survey" element={<Survey />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/hot-deals" element={<HotDeals />} />
        <Route path="/cart" element={<Cart theme={theme} setTheme={setTheme} />} />
        <Route path="/pay/:id" element={<Homes  />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route
          path="/product-details/:productId"
          element={<ProductDetails />}
        />
        <Route path="/register" element={<Register theme={theme} />} />
        <Route path="/username-input" element={<UsernameInput theme={theme} />} />
        <Route path="/profile" element={<Profile />} />
        <Route path='/:name' index element={<PublicProfile />}/>
        <Route path='/setup' index element={<SetUp />}/>
        <Route path='/rewards' index element={<Rewards />}/>
        <Route path='/rewardspage' index element={<RewardsPage />}/>
        <Route path='' element={<ResponsiveMenu theme={theme} setTheme={setTheme} />} />
      </Routes>
      {/* <div className='hidden lg:inline'> */}
      {/* <Cookies /> */}
      {/* </div> */}
      <ScrollToTop />
      <WhatsAppButton />
      <DigitalAssistant />
      <Footer2 />
    </div>
    </PopupProvider>
  );
}

export default App;
